import { Button, List, ListItemButton, Paper, Typography } from '@mui/material';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: ${props => props.theme.nav};
  flex-direction: column;
  height: 100vh;
  background-color: ${props => props.theme.palette.background.default};
  overflow: hidden;
`;

export const Logo = styled.div`
  display: flex;
  height: ${props => props.theme.layout.toolBarHeight.sm}px;
  padding: ${props => props.theme.spacing(1)};
  justify-content: center;

  ${props => props.theme.breakpoints.down('sm')} {
    height: ${props => props.theme.layout.toolBarHeight.xs}px;
  }

  ${props => props.theme.breakpoints.down('md')} {
    justify-content: space-between;
    align-items: center;
  }

  & img {
    max-height: 100%;
  }
`;

export const Footer = styled.div`
  height: ${props => props.theme.layout.toolBarHeight.sm}px;

  ${props => props.theme.breakpoints.down('sm')} {
    height: ${props => props.theme.layout.toolBarHeight.xs}px;
  }
`;

export const StyledContentWrapper = styled(Paper)`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const PropertySelectBox = styled.div`
  margin-top: ${props => props.theme.layout.toolBarHeight.sm}px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;

  ${props => props.theme.breakpoints.down('md')} {
    margin-top: 0;
  }

  &:hover {
    filter: brightness(1.05);
  }
`;

export const PropertySelectImage = styled.div`
  height: ${props => props.theme.spacing(8.25)};
  width: ${props => props.theme.spacing(8.25)};
  border-right: 1px solid ${props => props.theme.palette.grey[300]};

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const PropertyDevelopment = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.palette.primary.main};
  color: #fff;
  padding: ${props => props.theme.spacing(0.5)};
  padding-left: ${props => props.theme.spacing(1)};
  padding-bottom: 0;
  position: relative;

  & svg {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: ${props => props.theme.spacing(3)};
    border-bottom-left-radius: 5px;
  }

  & .MuiTypography-root {
    font-weight: 500;
    margin-right: ${props => props.theme.spacing(3)};
  }
`;

export const StyledNavItemsWrapper = styled.div`
  overflow-y: auto;
  flex-grow: 1;
`;

export const PropertySelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: ${props => props.theme.spacing(6)};
`;

export const SupportButton = styled(Button)`
  border-radius: 0px;
  border-top: 0px;
  height: 3rem;
  background-color: #fff;
  border-top: 1px solid ${props => props.theme.palette.grey[300]};
  color: ${props => props.theme.palette.secondary.main};
`;

export const PropertySelectNav = styled.div`
  display: flex;
  flex-direction: column;

  &:hover {
    background-color: ${props => props.theme.palette.grey[100]};
    cursor: pointer;
  }
`;
export const PropertySelectTitle = styled(Typography)`
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  padding: ${props => props.theme.spacing(0.5)};

  & svg {
    color: ${props => props.theme.palette.primary.main};
    font-size: 1.5rem;
  }
`;

export const PropertySelectInfo = styled.div`
  display: flex;
  padding: 0 ${props => props.theme.spacing(0.5)};
  padding-left: ${props => props.theme.spacing(1)};
  background-color: ${props => props.theme.palette.primary.main};
  color: #fff;
`;

export const PropertySelectDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  & div {
    color: ${props => props.theme.palette.text.secondary};
  }
`;

export const PropertySelectStatus = styled(Typography)`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => props.theme.spacing(0.25)} ${props => props.theme.spacing(1)};
  min-height: 2rem;
  margin: auto;
  margin-right: ${props => props.theme.spacing(1.5)};
  min-width: 4.2rem;
  max-width: 4.2rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: #333;

  &.status-active {
  }

  &.status-disabled {
  }
`;

export const PropertySelectValue = styled(Typography)`
  color: ${props => props.theme.palette.grey[50]};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;

  & span {
    font-weight: 400;
  }
`;

export const PropertySelectButton = styled(Button)`
  border-radius: 0px;
  border-top: 0px;
  height: 3rem;
  min-height: 3rem;
  background-color: ${props => props.theme.palette.secondary.main};
  border-bottom: 1px solid ${props => props.theme.palette.grey[300]};
  border-top: 1px solid ${props => props.theme.palette.grey[300]};
  color: #fff;

  & svg {
    color: #fff;
  }

  & a {
    text-decoration: none;
    color: #fff;
  }

  &:hover {
    background-color: ${props => props.theme.palette.secondary.light};
  }
`;

export const NestedList = styled(List)``;

export const StyledList = styled(List)`
  padding-top: 0px;
  padding-bottom: 0px;

  & .MuiListItemButton-root {
    padding-right: ${props => props.theme.spacing(0.5)};
    border-bottom: 1px solid ${props => props.theme.palette.grey[200]};
    color: ${props => props.theme.palette.grey[900]};

    & svg {
      color: ${props => props.theme.palette.grey[600]};
    }

    &:hover {
      background-color: ${props => props.theme.palette.grey[50]};
    }

    &:focus {
      background-color: ${props => props.theme.palette.primary.main};
      color: #fff;
      transition: all 0.1s ease-in;
    }

    & .MuiTypography-root {
      font-size: 14px;
      font-weight: 500;
    }
  }

  & .MuiListItem-root.Mui-selected {
    background-color: ${props => props.theme.palette.primary.main};
    color: #fff;
    border-bottom: 1px solid ${props => props.theme.palette.primary.main};
    border-top: 1px solid ${props => props.theme.palette.primary.main};

    & svg {
      color: #fff;
    }

    &:after {
      font-family: 'Material Icons';
      color: ${props => props.theme.palette.secondary.main};
      font-size: 1.4rem;
    }
  }

  & .MuiListItemIcon-root {
    min-width: ${props => props.theme.spacing(5)};
  }
`;

export const SelectedIcon = styled(ChevronRightIcon)`
  visibility: hidden;
`;

export const StyledListItem = styled(ListItemButton)`
  &.MuiListItem-root.Mui-selected ${SelectedIcon} {
    visibility: visible;
  }

  &:hover {
    cursor: pointer;
  }
`;
